import React from "react";
import { Link } from "react-router-dom";
import {
  Collapse,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  NavItem,
  NavLink,
} from "shards-react";
import Cookies from "universal-cookie";
import { doDelete } from "../../../../backend/common";
import { refresh } from "../../../../backend/userContext";
import FormLogin from "../../../forms/FormLogin";

export default class UserActions extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      visible: false,
    };

    this.toggleUserActions = this.toggleUserActions.bind(this);
    this.handleLogout = this.handleLogout.bind(this);
  }

  toggleUserActions() {
    this.setState({
      visible: !this.state.visible,
    });
  }

  dologout(callback) {
    //console.log("### Logout##");
    doDelete("/login", {}, callback).then();
  }

  handleLogout() {
    //console.log("Logout")
    this.dologout((data) => {
      //console.log("### Logout", data);
      if (data.error) {
        //console.log("### Logout Error")
      }
      const cookies = new Cookies();
      cookies.remove("connect.sid");
      refresh(this.props.user.setUser);
    });
  }

  render() {
    //console.log(this.props.user)
    if (this.props.user.user) {
      return (
        <div style={{ cursor: "pointer" }}>
          <NavItem tag={Dropdown} caret toggle={this.toggleUserActions}>
            <DropdownToggle caret tag={NavLink} className="text-nowrap px-3">
              <img
                className="user-avatar rounded-circle mr-2"
                src={require("../../../../images/avatars/avatar.png")}
                alt=""
              />{" "}
              <span
                className="d-none d-md-inline-block align-middle"
                style={{ fontSize: 15, paddingRight: 10 }}
              >
                {this.props.user.user.username}
              </span>
            </DropdownToggle>
            <Collapse tag={DropdownMenu} right small open={this.state.visible}>
              <DropdownItem tag={Link} to={"/profile"}>
                <i className="material-icons">&#xE7FD;</i> Perfil
              </DropdownItem>
              <DropdownItem divider />
              <DropdownItem
                className="text-danger"
                tag={Link}
                to={"/"}
                onClick={this.handleLogout}
              >
                <div>
                  <i className="material-icons text-danger">&#xE879;</i> Salir
                </div>
              </DropdownItem>
            </Collapse>
          </NavItem>
        </div>
      );
    } else {
      return (
        <div style={{ cursor: "pointer", width: "20vw" }}>
          <NavItem tag={Dropdown} toggle={this.toggleUserActions}>
            <DropdownToggle caret tag={NavLink} className="text-nowrap px-3">
              <span
                className="d-none d-md-inline-block align-middle"
                style={{ paddingRight: 10, fontSize: 15 }}
              >
                Entrar
              </span>
            </DropdownToggle>
            <Collapse tag={DropdownMenu} right small open={this.state.visible}>
              <FormLogin />
            </Collapse>
          </NavItem>
        </div>
      );
    }
  }
}
